import gql from 'graphql-tag';

const SalmonQuery = {
  salmonDonate: gql`
    mutation charity($data: PeopleCharityInput!) {
      charity(data: $data) {
        result
        data {
          totalAmount # Общая сумма пожертвований
          totalPeople # Сколько всего раз произвели пожерт.
          charityParticipantsMore # тест и еще ...
          currentUser {
            # служебная инфа о текущем пользователе
            id
            bill # текущий счет по бонусным рублям
            donated # true/false что было произведено пожертв.
          }
          participants {
            # все кто так же жертвовал
            amount # сумма (кол-во баллов)
            date
            people {
              id
              fio
              isCurrentUser # bool if true mark bold
            }
          }
        }
      }
    }
  `,
  getCharityDonations: gql`
    query getCharityDonations($data: PeopleCharityInput!) {
      getCharityDonations(data: $data) {
        result
        data {
          totalAmount # Общая сумма пожертвований
          totalPeople # Сколько всего раз произвели пожерт.
          charityParticipantsMore # тест и еще ...
          currentUser {
            # служебная инфа о текущем пользователе
            id
            bill # текущий счет по бонусным рублям
            donated # true/false что было произведено пожертв.
          }
          participants {
            # все кто так же жертвовал
            amount # сумма (кол-во баллов)
            date
            people {
              id
              fio
              isCurrentUser # bool if true mark bold
            }
          }
        }
      }
    }
  `
};

export default SalmonQuery;
